import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Auth } from "../firebase/firebase";
import { clearSearch, fetchUser } from "../actions";
import { Menu, Dropdown } from "semantic-ui-react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  let location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  let retailers = useSelector((state) => state.retailers);

  const [showButton, setShowButton] = useState("");

  useEffect(() => {
    if (!user) {
      switch (location.pathname) {
        case "/":
          setShowButton("Sign up");
          break;
        case "/register":
          setShowButton("Login");
          break;
        case "/forgotten-password":
          setShowButton("Login");
          break;
        case "/thankyou":
          setShowButton("Login");
          break;
        default:
          setShowButton("");
      }
    } else {
      setShowButton("");
    }
  }, [location, user]);

  const logout = () => {
    Auth.signOut();
    dispatch(fetchUser(null));
  };

  const RetailerLinks = () => {
    if (!retailers) return null;
    return retailers.map((retailer) => {
      const canUseSearchLookup =
        retailer.name === "tesco" && user.organisation === "dunnhumby";
      const canUseRangeLookup =
        ["tesco", "tesco_ie"].includes(retailer.name) &&
        user.organisation === "dunnhumby";

      if (canUseSearchLookup || canUseRangeLookup) {
        return (
          <Dropdown.Item key={retailer.name} className="bm-retailer-submenu">
            <span>{retailer.displayName}</span>
            <i aria-hidden="true" className="dropdown icon"></i>
            <Dropdown.Menu>
              <Dropdown.Item
                as={Link}
                to={`/${retailer.name}/list/1`}
                onClick={() => dispatch(clearSearch())}
              >
                 List
              </Dropdown.Item>
              {canUseSearchLookup && (
                <Dropdown.Item
                  as={Link}
                  to={`/${retailer.name}/sku-checker`}
                >
                  Search lookup
                </Dropdown.Item>
              )}
              {canUseRangeLookup && (
                <Dropdown.Item
                  as={Link}
                  to={`/${retailer.name}/range-checker`}
                >
                  Range lookup
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown.Item>
        );
      }

      return (
        <Dropdown.Item
          as={Link}
          to={`/${retailer.name}/list/1`}
          key={retailer.name}
          onClick={() => dispatch(clearSearch())}
        >
          {retailer.displayName}
        </Dropdown.Item>
      );
    });
  };

  return (
    <Menu fixed="top" className="bm-header">
      <Menu.Item as={Link} to="/" header>
        <h1>BannerMatic</h1>
      </Menu.Item>
      {user && user.isEditor && (
        <Dropdown item text="Menu" simple>
          <Dropdown.Menu>
            <Dropdown.Item
              as={Link}
              to="/"
              onClick={() => dispatch(clearSearch())}
            >
              Dashboard
            </Dropdown.Item>
            <RetailerLinks />
          </Dropdown.Menu>
        </Dropdown>
      )}
      {user && user.isAdmin && (
        <Dropdown item icon="settings" className="icon">
          <Dropdown.Menu>
            <Dropdown.Item as={Link} to="/admin/retailers">
              Retailers
            </Dropdown.Item>
            <Dropdown.Item as={Link} to="/admin/users/1">
              Users
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}
      {user && (
        <Menu.Item>
          <span className="displayname">Hello {user.displayName} </span>
          <i
            aria-hidden="true"
            className="teal log out link icon large"
            onClick={logout}
            title="log out"
          ></i>
        </Menu.Item>
      )}
      {showButton && (
        <Menu.Item>
          <Link to={showButton === "Login" ? "/" : "/register"}>
            {showButton}
          </Link>
        </Menu.Item>
      )}
    </Menu>
  );
};

export default Header;
